import { DEFAULT_NUTRIENT_UOM } from "./constants";

export const newAllergySection = () => {
    return {
        contains: [],
        mayContain: [],
        doesNotContain: [],
    };
};

export const newHealthClaimSection = () => {
    return {
        items: [],
    };
};

export const newCalorie = () => {
    return {
        servingText: "",
        calories: 0,
        caloriesFromFat: null,
    };
};

export const newFootnoteSection = () => {
    return {
        items: [],
    };
};

export const newIngredientsSection = () => {
    return {
        leadIn: "",
        items: [],
    };
};

export const newColumn = () => {
    return {
        header: "",
        servingAccuracy: "",
        servingSize: "",
        servingSizeMetric: "",
        servingSizeVisual: "",
        servingsPerContainer: "",
        servingSizeDescription: "",
        calorie: newCalorie(),
        dietary: { facts: [newFact()] },
        vitamineral: { facts: [newFact()] },
    };
};

export const createPanel = () => {
    return {
        header: "",
        columns: [newColumn()],
        ingredients: newIngredientsSection(),
        footnotes: newFootnoteSection(),
        allergens: newAllergySection(),
        healthClaims: newHealthClaimSection(),
    };
};

export const newFact = (id) => {
    var uniqid = id || Date.now();

    return {
        nutrient: { value: uniqid, text: "" },
        quantity: "",
        uom: "",
        pdv: {
            value: "",
            uom: { value: "percent", text: "%" },
        },
        noteMark: "",
        description: "",
    };
};

export const cloneFacts = (facts) => {
    const newFacts = facts.facts.map((f) => {
        const nf = newFact(f.nutrient.value);
        nf.name = f.name;
        nf.nutrient.text = f.nutrient.text;

        if (f.nutrient.code) {
            nf.nutrient.code = f.nutrient.code;
        }

        const defaultUom = DEFAULT_NUTRIENT_UOM[nf.nutrient.value];

        if (defaultUom) {
            nf.uom = defaultUom;
        }

        return nf;
    });

    return { facts: newFacts };
};

export const cloneCalorie = (cal) => {
    return {
        servingText: "",
        calories: 0,
        caloriesFromFat: cal.caloriesFromFat === null ? null : 0,
    };
};

export const cloneColumn = (column) => {
    return {
        header: "",
        servingAccuracy: "",
        servingSize: "",
        servingSizeMetric: "",
        servingSizeVisual: "",
        servingsPerContainer: "",
        servingSizeDescription: "",
        calorie: cloneCalorie(column.calorie),
        dietary: cloneFacts(column.dietary),
        vitamineral: cloneFacts(column.vitamineral),
    };
};

export const nutrientValidation = (nutrients) => {
    let nutrientsValid = true;
    nutrients.forEach((item) => {
        if (!item.nutrient.text) {
            nutrientsValid = false;
        }
    });

    return nutrientsValid;
};

export const createOptions = (values, labelPrefix) => {
    if (!values) {
        return [];
    }

    return values.map((pane, index) => {
        return {
            value: index,
            text: `${labelPrefix} ${index + 1}`,
        };
    });
};
